import { SvgIcon } from "./SvgIcon";

export const CaretDownIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  strokeWidth = 1.2,
  fillColor = "none"
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    className={`stroke-current ${strokeColor}`}
  >
    <path
      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaretUpIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  strokeWidth = 1.2,
  fillColor = "none"
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    className={`stroke-current ${strokeColor}`}
  >
    <path
      d="M10.707 7.05L10 6.343 4.343 12l1.414 1.414L10 9.172l4.243 4.242L15.657 12z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaretRightIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  strokeWidth = 1.2,
  fillColor = "none"
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    className={`stroke-current ${strokeColor}`}
  >
    <path
      d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CaretLeftIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  strokeWidth = 1.2,
  fillColor = "none"
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 404.258 404.258"
    className={`stroke-current ${strokeColor}`}
  >
    <polygon
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      points="324.7,28.238 296.37,0 89.796,207.248 296.37,414.496 324.7,386.258 146.273,207.248 "
    />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

export const GoForwardIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  strokeWidth = 1.2,
  fillColor = "none"
}) => (
  <svg
    data-testid="goFwdIcon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    className={`stroke-current ${strokeColor}`}
  >
    <polygon
      points="16.172 9 10.101 2.929 11.515 1.515 20 10 19.293 10.707 11.515 18.485 10.101 17.071 16.172 11 0 11 0 9"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoBackIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  strokeWidth = 1.2,
  fillColor = "none"
}) => (
  <svg
    data-testid="goBackIcon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    className={`stroke-current ${strokeColor}`}
  >
    <path
      d="M3.828 9l6.071-6.071-1.414-1.414L0 10l.707.707 7.778 7.778 1.414-1.414L3.828 11H20V9H3.828z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MoreIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  strokeWidth = 1.2,
  fillColor = "none"
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    className={`stroke-current ${strokeColor}`}
  >
    <path
      d="M4 12a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm6 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyIcon: SvgIcon = ({
  width = 25,
  height = 13,
  strokeColor = "text-white",
  strokeWidth = 1.2,
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    data-cy="copy-link"
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      strokeWidth={strokeWidth}
      d="M6.5 15.25C5.5335 15.25 4.75 14.4665 4.75 13.5V6.75C4.75 5.64543 5.64543 4.75 6.75 4.75H13.5C14.4665 4.75 15.25 5.5335 15.25 6.5"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      strokeWidth={strokeWidth}
      d="M8.75 10.75C8.75 9.64543 9.64543 8.75 10.75 8.75H17.25C18.3546 8.75 19.25 9.64543 19.25 10.75V17.25C19.25 18.3546 18.3546 19.25 17.25 19.25H10.75C9.64543 19.25 8.75 18.3546 8.75 17.25V10.75Z"
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CollapseIcon: SvgIcon = ({ width = 25, height = 25, strokeColor = "text-black", fillColor = "none" }) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 46"
    className={`fill-current ${strokeColor}`}
  >
    <path d="M12.6175 29.3558C13.1056 28.8814 13.8983 28.8814 14.3864 29.3558L20.6339 35.4275C21.122 35.9019 21.122 36.6722 20.6339 37.1466C20.1458 37.621 19.3532 37.621 18.8651 37.1466L14.7495 33.143L14.7495 44.7856C14.7495 45.4573 14.1911 46 13.5 46C12.8089 46 12.2505 45.4573 12.2505 44.7856L12.2505 33.143L8.13491 37.1428C7.64682 37.6172 6.85416 37.6172 6.36607 37.1428C5.87798 36.6685 5.87798 35.8981 6.36607 35.4237L12.6136 29.352L12.6175 29.3558Z" />
    <path d="M12.6175 16.6442C13.1056 17.1186 13.8983 17.1186 14.3864 16.6442L20.6339 10.5725C21.122 10.0981 21.122 9.32775 20.6339 8.8534C20.1458 8.37904 19.3532 8.37904 18.8651 8.8534L14.7495 12.857L14.7495 1.21435C14.7495 0.542665 14.1911 1.3121e-06 13.5 1.25168e-06C12.8089 1.19126e-06 12.2505 0.542665 12.2505 1.21435L12.2505 12.857L8.13491 8.85719C7.64682 8.38283 6.85416 8.38283 6.36607 8.85719C5.87798 9.33155 5.87798 10.1019 6.36607 10.5763L12.6136 16.648L12.6175 16.6442Z" />
    <rect y="22" width="27" height="3" rx="1.5" />
  </svg>
);

export const ExpandIcon: SvgIcon = ({ width = 25, height = 25, strokeColor = "text-black", fillColor = "#666666" }) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 46"
    className={`fill-current ${strokeColor}`}
  >
    <path d="M12.6175 45.6442C13.1056 46.1186 13.8983 46.1186 14.3864 45.6442L20.6339 39.5725C21.122 39.0981 21.122 38.3278 20.6339 37.8534C20.1458 37.379 19.3532 37.379 18.8651 37.8534L14.7495 41.857L14.7495 30.2144C14.7495 29.5427 14.1911 29 13.5 29C12.8089 29 12.2505 29.5427 12.2505 30.2144L12.2505 41.857L8.13491 37.8572C7.64682 37.3828 6.85416 37.3828 6.36607 37.8572C5.87798 38.3315 5.87798 39.1019 6.36607 39.5763L12.6136 45.648L12.6175 45.6442Z" />
    <path d="M12.6175 0.355768C13.1056 -0.118589 13.8983 -0.118589 14.3864 0.355768L20.6339 6.42753C21.122 6.90189 21.122 7.67225 20.6339 8.1466C20.1458 8.62096 19.3532 8.62096 18.8651 8.1466L14.7495 4.14303L14.7495 15.7856C14.7495 16.4573 14.1911 17 13.5 17C12.8089 17 12.2505 16.4573 12.2505 15.7856L12.2505 4.14303L8.13491 8.14281C7.64682 8.61717 6.85416 8.61717 6.36607 8.14281C5.87798 7.66845 5.87798 6.8981 6.36607 6.42374L12.6136 0.351973L12.6175 0.355768Z" />
    <rect y="22" width="27" height="3" rx="1.5" />
  </svg>
);

export const DoubleArrowIcon: SvgIcon = ({
  width = 17,
  height = 17,
  strokeColor = "text-black",
  fillColor = "#666666",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 27 27"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      d="M14.8616 15.4443C14.1085 16.2269 12.8855 16.2269 12.1324 15.4443L0.564821 3.42319C-0.188274 2.64057 -0.188274 1.36959 0.564821 0.586966C1.31792 -0.195657 2.54095 -0.195657 3.29404 0.586966L13.5 11.1931L23.706 0.593228C24.4591 -0.189395 25.6821 -0.189395 26.4352 0.593228C27.1883 1.37585 27.1883 2.64683 26.4352 3.42945L14.8676 15.4505L14.8616 15.4443Z"
      fill="#666666"
    />
    <path
      d="M14.8616 26.413C14.1085 27.1957 12.8855 27.1957 12.1324 26.413L0.564821 14.3919C-0.188274 13.6093 -0.188274 12.3383 0.564821 11.5557C1.31792 10.7731 2.54095 10.7731 3.29404 11.5557L13.5 22.1618L23.706 11.562C24.4591 10.7794 25.6821 10.7794 26.4352 11.562C27.1883 12.3446 27.1883 13.6156 26.4352 14.3982L14.8676 26.4193L14.8616 26.413Z"
      fill="#666666"
    />
  </svg>
);

export const InfoIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeColor = "text-black",
  fillColor = "#666666",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 4C8.26522 4 8.51957 4.10536 8.70711 4.29289C8.89464 4.48043 9 4.73478 9 5C9 5.26522 8.89464 5.51957 8.70711 5.70711C8.51957 5.89464 8.26522 6 8 6C7.73478 6 7.48043 5.89464 7.29289 5.70711C7.10536 5.51957 7 5.26522 7 5C7 4.73478 7.10536 4.48043 7.29289 4.29289C7.48043 4.10536 7.73478 4 8 4Z" />
  </svg>
);

export const TickIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeColor = "text-black",
  fillColor = "#666666",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
  </svg>
);

export const ArrowIcon: SvgIcon = ({
  width = 50,
  height = 50,
  strokeColor = "text-black",
  fillColor = "#666666",
  classes,
  title
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 70 60"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <title>{title}</title>
    <path d="M68.5351 26.4701C70.4883 28.4225 70.4883 31.5931 68.5351 33.5455L43.5337 58.5357C41.5804 60.4881 38.4084 60.4881 36.4552 58.5357C34.5019 56.5834 34.5019 53.4127 36.4552 51.4604L52.9405 34.9981L5.00028 34.998C2.2345 34.998 1.1905e-06 32.7645 1.31134e-06 30C1.43218e-06 27.2355 2.2345 25.002 5.00028 25.002L52.9405 25.002L36.4708 8.53964C34.5176 6.58727 34.5176 3.41664 36.4708 1.46427C38.424 -0.488088 41.5961 -0.488088 43.5493 1.46427L68.5507 26.4545L68.5351 26.4701Z" />
  </svg>
);

export const EditIcon: SvgIcon = ({
  width = 13,
  height = 13,
  strokeColor = "text-black",
  fillColor = "#666666",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13 13"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path d="M9.21903 0.476556L7.98879 1.7067L11.2932 5.01082L12.5234 3.78067C13.1589 3.14527 13.1589 2.11591 12.5234 1.4805L11.5219 0.476556C10.8865 -0.158852 9.85703 -0.158852 9.22157 0.476556H9.21903ZM7.41433 2.28111L1.48933 8.20819C1.22498 8.47252 1.03181 8.80039 0.925049 9.15876L0.0252421 12.2163C-0.0383036 12.4324 0.0201585 12.6637 0.177752 12.8212C0.335345 12.9788 0.566651 13.0373 0.780165 12.9763L3.83798 12.0766C4.19638 11.9698 4.52428 11.7766 4.78863 11.5123L10.7187 5.58523L7.41433 2.28111Z" />
  </svg>
);

export const ArchiveIcon: SvgIcon = ({
  width = 17,
  height = 15,
  strokeColor = "text-black",
  fillColor = "#666666",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 15"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path d="M1.0625 0H15.9375C16.5252 0 17 0.478795 17 1.07143V2.14286C17 2.73549 16.5252 3.21429 15.9375 3.21429H1.0625C0.474805 3.21429 0 2.73549 0 2.14286V1.07143C0 0.478795 0.474805 0 1.0625 0ZM1.0625 4.28571H15.9375V12.8571C15.9375 14.0391 14.9846 15 13.8125 15H3.1875C2.01543 15 1.0625 14.0391 1.0625 12.8571V4.28571ZM5.3125 6.96429C5.3125 7.25893 5.55156 7.5 5.84375 7.5H11.1562C11.4484 7.5 11.6875 7.25893 11.6875 6.96429C11.6875 6.66964 11.4484 6.42857 11.1562 6.42857H5.84375C5.55156 6.42857 5.3125 6.66964 5.3125 6.96429Z" />
  </svg>
);
export const ReloadIcon: SvgIcon = ({
  width = 25,
  height = 25,
  strokeColor = "text-gray-500",
  fillColor = "none",
  classes
}) => (
  <svg
    data-cy="cancel-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 83 83"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path d="M77.8125 41.5C77.8125 61.5043 61.5205 77.7963 41.5162 77.7963C33.5955 77.7963 26.085 75.2706 19.7611 70.5241C17.4689 68.8073 17.0053 65.5538 18.7251 63.2599C20.4451 60.9758 23.7002 60.509 25.9876 62.2265C30.5007 65.6162 35.8763 67.4043 41.5323 67.4043C55.8143 67.4051 67.4375 55.7818 67.4375 41.5C67.4375 27.2182 55.8191 15.5949 41.5324 15.5949C33.3783 15.5982 25.7105 19.5018 20.8473 25.9375H31.125C33.9895 25.9375 36.3125 28.2573 36.3125 31.125C36.3125 33.9927 33.9943 36.3125 31.125 36.3125H7.78125C4.91678 36.3125 2.59375 33.9927 2.59375 31.125V7.78125C2.59375 4.91354 4.91678 2.59375 7.78125 2.59375C10.6457 2.59375 12.9688 4.91354 12.9688 7.78125V19.1662C19.7936 10.469 30.1686 5.20533 41.5162 5.20533C61.5205 5.20533 77.8125 21.4957 77.8125 41.5Z" />
  </svg>
);

export const ChevronLeftIcon: SvgIcon = ({
  width = 19,
  height = 17,
  strokeColor = "text-black",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 17"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <g clipPath="url(#clip0_686_1824)">
      <path d="M12.1222 15.7205L12.3753 15.4811C12.5429 15.3227 12.5502 15.0591 12.3918 14.8915L5.80061 7.9247L12.7709 1.33363C12.9384 1.17517 12.9458 0.911574 12.7874 0.744002L12.548 0.490862C12.3895 0.323291 12.1259 0.315921 11.9584 0.474376L4.43201 7.58792C4.26443 7.74637 4.25706 8.00997 4.41552 8.17754L11.5326 15.7005C11.691 15.8716 11.9546 15.8789 12.1222 15.7205Z" />
    </g>
    <defs>
      <clipPath id="clip0_686_1824">
        <rect width="15.5444" height="17.765" fill="white" transform="translate(18.1924 0.496094) rotate(91.6016)" />
      </clipPath>
    </defs>
  </svg>
);
export const ChevronDownIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  strokeWidth = 1.2,
  fillColor = "none",
  classes = ""
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      fillRule="evenodd"
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
      strokeWidth={strokeWidth}
    />
  </svg>
);
